var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 8,
    fill: "#37D4AF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 22.2857C52 19.9196 50.0804 18 47.7143 18H16.2857C13.9196 18 12 19.9196 12 22.2857V42.2857C12.0036 42.9214 12.15 43.55 12.4286 44.1214L12.4179 44.1321L12.4536 44.1678C12.8714 45.0143 13.5572 45.7 14.4036 46.1178L14.4375 46.1518L14.4482 46.1411C15.0214 46.4214 15.6482 46.5678 16.2857 46.5714H47.7143C48.3517 46.5678 48.9785 46.4214 49.5517 46.1428L49.5625 46.1536L49.5964 46.1196V46.1178C50.4428 45.7018 51.1286 45.016 51.5464 44.1678L51.5821 44.1321L51.5714 44.1214V44.1232C51.85 43.55 51.9964 42.9232 52 42.2857L52 22.2857ZM32.6409 33.4377C32.4748 33.6145 32.2409 33.7145 31.9981 33.7145C31.7552 33.7145 31.5231 33.6145 31.3552 33.4377L17.0215 20.8571H46.9767L32.6409 33.4377ZM14.8571 22.7575L24.9426 31.6146L14.8571 41.6933V22.7575ZM16.875 43.7147L27.0931 33.4967L29.4699 35.5842H29.4716C30.9038 36.8913 33.0949 36.8913 34.5272 35.5842L36.9057 33.4967L47.1252 43.7147H16.875ZM39.057 31.6096L49.1424 22.7579V41.6937L39.057 31.6096Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.f987f93bca15f163b4f2d61a573cfefc.svg";
export { ForwardRef as ReactComponent };